var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1773647012556,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12051,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M788 929.2c-94.8 0-172-77.2-172-172s77.2-172 172-172 172 77.2 172 172-77.2 172-172 172z m0-280c-59.6 0-108 48.4-108 108s48.4 108 108 108 108-48.4 108-108-48.5-108-108-108zM788 403.2c-83.8 0-152-68.2-152-152s68.2-152 152-152 152 68.2 152 152-68.2 152-152 152z m0-240c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zM270.3 719c-114.1 0-207-92.9-207-207s92.9-207 207-207 207 92.9 207 207-92.8 207-207 207z m0-350c-78.9 0-143 64.1-143 143s64.1 143 143 143 143-64.1 143-143-64.1-143-143-143z",
    fill: "#333333",
    "p-id": 12052
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M686.854 265.65l32 55.425-285.78 165-32-55.424zM426.144 625.744l32-55.424 199.18 115-32 55.424z",
    fill: "#333333",
    "p-id": 12053
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFx);
export default __webpack_public_path__ + "static/media/fx.04c823cf088b8301095cf01ab283c0cd.svg";
export { ForwardRef as ReactComponent };